import moment from 'moment';
//import getWeather from './weather';

const CALENDAR_ID = "adah9imhp603597pmmdq6odrl4@group.calendar.google.com";
const CALENDAR_KEY = "AIzaSyDw8tvOO9fygtdwEGJnGoC-OIJ6b-csS7E";

// Why do we need a global there ?
let calendars = {};

/**
 * Get the calendar data and return the collection events
 * with the good data format
 */
export default function getCalendar () {
  let today = new Date().toISOString();

  $.ajax({
    type: 'GET',
    url: encodeURI(`https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?maxResults=53&timeMin=${today}&key=${CALENDAR_KEY}`),
    dataType: 'json',
    success: (response) => {
      let currentDay = moment().format('YYYY-MM-DD');
      let openDZ = false;

      let eventsCal = response.items.map((event) => {
        // The DZ is opened if it's in an event boundaries
        if (currentDay >= moment(event.startDate).format('YYYY-MM-DD') &&
            currentDay <= moment(event.endDate).format('YYYY-MM-DD')) {
          openDZ = true;
        }

        let obj = {
          title: event.summary,
          month: moment(event.start.date).format('MMM'),
          startDate: event.start.date,
          endDate: moment(event.end.date).add(-1, 'day'),
          className: event.description ? 'sm-event' : 'sm-open',
        };

        if(event.description) {
          let tokens = event.description.split(';');
          if(tokens.length >= 2)
            obj.desc = tokens.shift();
          obj.href = tokens.shift();
        }

        return obj;
      });

      displayCalendar(eventsCal);
//      getWeather(openDZ);
    },
    error: error => {
      console.log(error);
    }
  });
}

/**
 * Set params of the calendar plugins with the google calendar data
 * Create the HTML parts of codes when an event exist
 * @param smEvent (collection)
 */
function displayCalendar(smEvent) {
  let thisMonth = moment().format('YYYY-MM');
  let eventArray = smEvent;

  if($('.cal1').length) {
    currentEvents(thisMonth, eventArray);

    calendars.clndr1 = $('.cal1').clndr({
      events: eventArray,
      weekOffset: 1,
      daysOfTheWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      clickEvents: {
        onMonthChange: (month) => {
          currentEvents(month, eventArray);
        }
      },
      multiDayEvents: {
        singleDay: 'date',
        endDate: 'endDate',
        startDate: 'startDate'
      },
      showAdjacentMonths: true,
      adjacentDaysChangeMonth: false
    });
  }
}

function currentEvents(month, eventArray) {
  let eventsList = eventArray.filter((event) => {
    return new Date(event.startDate).getMonth() === new Date(month).getMonth();
  });

  $('.events').empty();

  let dateItem = '';
  let dateItemEnd = '';

  if (!eventsList.length || !hasHref(eventsList)) {
    $('.events').append('<li class="no-item">Aucun événement ce mois-ci</li>');
  } else {
    for (var i = 0; i < eventsList.length; i++) {
      dateItem = eventsList[i].startDate.split('-').pop();
      dateItemEnd = eventsList[i].endDate._d.getDate();

      dateItemEnd = (String(dateItemEnd).length == 1) ? '0' + String(dateItemEnd) : dateItemEnd;

      if (eventsList[i].href && dateItemEnd > dateItem) {
        $('.events').prepend(
          '<li class="event-item sm-container sm-container--hoverable">' +
          '<a href="' + eventsList[i].href + '" target="_blank"><div class="date"><div><small>du </small>' + dateItem + '<br><small>au </small>' + dateItemEnd + '<br><span class="month">' + eventsList[i].month + '</span></div></div>' +
          '<div class="event-desc"><h4>' + eventsList[i].title + '</h4></div><i class="fa fa-chevron-right chevron"></i></a></li>');
      } else if (eventsList[i].href && dateItemEnd == dateItem) {
        $('.events').prepend(
          '<li class="event-item sm-container sm-container--hoverable">' +
          '<a href="' + eventsList[i].href + '" target="_blank"><div class="date"><div>' + dateItem + '<br><span class="month">' + eventsList[i].month + '</span></div></div>' +
          '<div class="event-desc"><h4>' + eventsList[i].title + '</h4></div><i class="fa fa-chevron-right chevron"></i></a></li>');
      } else if (eventsList[i].href && eventsList[i].desc) {
        $('.events').prepend(
          '<li class="event-item sm-container sm-container--hoverable">' +
          '<a href="' + eventsList[i].href + '" target="_blank"><div class="date"><div>' + dateItem + '<br><span class="month">' + eventsList[i].month + '</span></div></div>' +
          '<div class="event-desc"><h4>' + eventsList[i].title + '</h4><p>' + eventsList[i].desc + '</p></div><i class="fa fa-chevron-right chevron"></i></a></li>');
      } else if (eventsList[i].href && eventsList[i].desc) {
        $('.events').prepend(
          '<li class="event-item sm-container sm-container--hoverable">' +
          '<a href="' + eventsList[i].href + '" target="_blank"><div class="date"><div>' + dateItem + '<br><span class="month">' + eventsList[i].month + '</span></div></div>' +
          '<div class="event-desc"><h4>' + eventsList[i].title + '</h4><p>' + eventsList[i].desc + '</p></div><i class="fa fa-chevron-right chevron"></i></a></li>');
      }
    }
  }
}

/**
* Check if an event has a link inside it description
* @param events (collection)
* @returns {boolean}
*/
function hasHref (events) {
  var hasEvent = false;

  events.forEach((event) => {
    if (event.href || event.desc) {
      hasEvent = true;
    }
  });

  return hasEvent;
}
